import React from 'react';

const Help = () => {
    const handleClick = (e) => {
        window.open('mailto:support@freightsmith.net?subject=Subject&body=Body%20goes%20here')
    }

    return (
        <div className="content-page">
            <div className="content">
                <div className="contest_input_block">
                    <div className="contest_preview">
                        <div className="top_header_bar">
                            <div className="row">
                                <div className="col-sm col-xl-4 d-flex align-items-center p-0">

                                    <h3 className="m-0 h3-heading"><i
                                        className="fal fa-question-circle"></i> Help</h3>
                                </div>
                            </div>
                        </div>

                        <div className="container_block" style={{ padding: "20px" }}>
                            <div className="row">
                                <div className="col-sm-12 col-xxl-12">
                                    <div className="row">
                                        <div className="form-group col-sm-6">
                                            <span className="gray_label">Contact Center Suport</span>
                                            <p><i className="fal fa-phone-alt fa-fw"></i> (855) 752-2878</p>
                                        </div>
                                    </div>
                                    <hr className="clearfix" />
                                    <div className="row">
                                        <div className="form-group col-sm-6">
                                            <span className="gray_label">Mail</span>
                                            <p><i className="fal fa-envelope fa-fw"></i><input className="btn-bg-none" type="button" onClick={handleClick} value="support@freightsmith.net"></input> </p>
                                        </div>
                                    </div>
                                    <hr className="clearfix" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </div>

    )
}

export default Help;